import React, { ReactNode, useEffect, useRef } from 'react'
import { CupertinoPane } from 'cupertino-pane/dist/core'
import { BackdropModule, FitHeightModule } from 'cupertino-pane/dist/modules'
import './styles.css'

export interface PanelProps {
  panelKey: string
  children: ReactNode
  onClosed: () => void
  openPanel: boolean
}

const CupertinoPanel: React.FC<PanelProps> = ({ panelKey, openPanel, onClosed, children }) => {
  const drawerRef = useRef<CupertinoPane>()
  const isShowing = useRef(false)

  const hidePanel = () => {
    if (isShowing.current === true) {
      isShowing.current = false
      drawerRef.current?.destroy({ animate: true })
    }
  }

  useEffect(() => {
    drawerRef.current = new CupertinoPane(`.${panelKey}`, {
      modules: [BackdropModule, FitHeightModule],
      parentElement: '#root',
      bottomClose: true,
      backdrop: true,
      backdropOpacity: 0.3,
      fitHeight: true,
      maxFitHeight: 600,
    })
    drawerRef.current.on('onBackdropTap', () => hidePanel())
    drawerRef.current.on('onDidDismiss', () => {
      document.body.classList.remove('overflow-y-hidden')
      isShowing.current = false
      hidePanel()
    })
    drawerRef.current.on('onDidPresent', () => document.body.classList.add('overflow-y-hidden'))
  }, [panelKey])

  useEffect(() => {
    const showPanel = () => {
      isShowing.current = true
      drawerRef.current?.present({ animate: true })
    }
    if (openPanel) {
      showPanel()
    }
    drawerRef.current.on('onWillDismiss', () => onClosed())
  }, [openPanel, onClosed])

  return <div className={panelKey}>{children}</div>
}

export default CupertinoPanel
